import { render, staticRenderFns } from "./averageWastePerGuestPerDay.vue?vue&type=template&id=0f58f81f"
import script from "./averageWastePerGuestPerDay.js?vue&type=script&lang=js&external"
export * from "./averageWastePerGuestPerDay.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports